var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopHeaderImagePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 87,
    viewBox: "0 0 1600 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -106,
    width: 1600,
    height: 1200,
    fill: "#0C1356"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9368_138817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -106,
    width: 1600,
    height: 1200
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -106,
    width: 1600,
    height: 1200,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9368_138817)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -445.062,
    width: 1135,
    height: 851.25,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.625,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 52.5C566 13.0116 598.012 -19 637.5 -19H707.604C708.375 -19 709 -18.375 709 -17.604C709 59.4972 646.497 122 569.396 122H566V52.5Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.875 -12.1688C141.875 -16.1832 145.129 -19.4375 149.144 -19.4375H283.75V51.5C283.75 90.6777 251.99 122.438 212.812 122.438C173.635 122.438 141.875 90.6777 141.875 51.5V-12.1688Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.5 122.438H425.625C425.625 83.2598 457.385 51.5 496.562 51.5C535.74 51.5 567.5 83.2598 567.5 122.438Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.75,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.25,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.25 -19.4375H922.188C961.365 -19.4375 993.125 12.3223 993.125 51.5V121.265C993.125 121.913 992.6 122.438 991.952 122.438C914.245 122.438 851.25 58.2703 851.25 -19.4375Z",
    fill: "#111747"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 993.125,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.375 51.5C709.375 12.3223 741.135 -19.4375 780.312 -19.4375H851.25V122.438H780.312C741.135 122.438 709.375 90.6777 709.375 51.5Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993.125 -19.4375C993.125 19.7402 961.365 51.5 922.188 51.5C922.188 12.3223 953.947 -19.4375 993.125 -19.4375Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.875 122.438V-19.4375C181.053 -19.4375 212.812 12.3223 212.812 51.5C212.812 90.6777 181.053 122.438 141.875 122.438Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 122.438C0 83.2598 31.7598 51.5 70.9375 51.5C70.9375 90.6777 39.1777 122.438 0 122.438Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.812,
    y: 51.5,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.75,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.969,
    y: 16.0312,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.844,
    y: 16.0312,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.344,
    y: 16.0312,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#111747"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.438 51.5C638.438 90.6777 606.678 122.438 567.5 122.438C567.5 83.2598 599.26 51.5 638.438 51.5Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.625 51.5C425.625 90.6777 393.865 122.438 354.688 122.438C354.688 83.2598 386.447 51.5 425.625 51.5ZM283.75 193.375C283.75 154.197 315.51 122.438 354.688 122.438C354.688 161.615 322.928 193.375 283.75 193.375ZM354.688 122.438C315.51 122.438 283.75 90.6777 283.75 51.5C322.928 51.5 354.688 83.2598 354.688 122.438ZM354.688 122.438C393.865 122.438 425.625 154.197 425.625 193.375C386.447 193.375 354.688 161.615 354.688 122.438Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135,
    y: -445.062,
    width: 1135,
    height: 851.25,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1558,
    y: -19,
    width: 144,
    height: 141,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 -11.7761C1277 -15.7657 1280.23 -19 1284.22 -19H1420V50.5C1420 89.9884 1387.99 122 1348.5 122C1309.01 122 1277 89.9884 1277 50.5V-11.7761Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1702.5 122.438H1560.62C1560.62 83.2598 1592.38 51.5 1631.56 51.5C1670.74 51.5 1702.5 83.2598 1702.5 122.438Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1418.75,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135,
    y: -19,
    width: 147,
    height: 141,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.88 122.438V-19.4375C1316.05 -19.4375 1347.81 12.3223 1347.81 51.5C1347.81 90.6777 1316.05 122.438 1276.88 122.438Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1135 122.438C1135 83.2598 1166.76 51.5 1205.94 51.5C1205.94 90.6777 1174.18 122.438 1135 122.438Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1347.81,
    y: 51.5,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1418.75,
    y: -19.4375,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1312.34,
    y: 18.0312,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#111747"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.62 51.5C1560.62 90.6777 1528.87 122.438 1489.69 122.438C1489.69 83.2598 1521.45 51.5 1560.62 51.5ZM1418.75 193.375C1418.75 154.197 1450.51 122.438 1489.69 122.438C1489.69 161.615 1457.93 193.375 1418.75 193.375ZM1489.69 122.438C1450.51 122.438 1418.75 90.6777 1418.75 51.5C1457.93 51.5 1489.69 83.2598 1489.69 122.438ZM1489.69 122.438C1528.87 122.438 1560.62 154.197 1560.62 193.375C1521.45 193.375 1489.69 161.615 1489.69 122.438Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 86,
    r: 10,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHeaderImagePattern);
export default __webpack_public_path__ + "static/media/top-header-image-pattern.d130f23a2c519aecf2e4bdeedaad0241.svg";
export { ForwardRef as ReactComponent };